import React from "react"
import { Col, Card, CardBody, CardImg } from "reactstrap"

// Gatsby Specific Imports
import { graphql, Link, useStaticQuery } from "gatsby"
import { getSrc, getSrcSet } from "gatsby-plugin-image"

const BlogBox = () => {
  const data = useStaticQuery(graphql`
    {
      allMarkdownRemark(
        filter: { frontmatter: { contentKey: { eq: "blog" } } }
        limit: 3
        sort: { fields: frontmatter___date, order: DESC }
      ) {
        nodes {
          frontmatter {
            title
            date
            author {
              author_s_name
            }
            thumbnail {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          id
          timeToRead
          fields {
            slug
          }
        }
      }
    }
  `)

  const blogs = data.allMarkdownRemark.nodes.map(blog => ({
    id: blog.id,
    image: blog.frontmatter.thumbnail,
    title: blog.frontmatter.title,
    author: blog.frontmatter.author.author_s_name,
    date: blog.frontmatter.date,
    timeToRead: blog.timeToRead,
    link: blog.fields.slug,
  }))

  return (
    <>
      {blogs.map(blog => (
        <Col lg="4" md="6" className="mt-4 pt-2" key={blog.id} name="blog">
          <Card className="blog rounded border-0 shadow">
            <div className="position-relative">
              <CardImg
                top
                src={getSrc(blog.image)}
                srcSet={getSrcSet(blog.image)}
                className="rounded-top"
                alt="thumbnail"
              />
              <div className="overlay rounded-top bg-dark"></div>
            </div>
            <CardBody className="content">
              <h5>
                <Link
                  to={`/blog${blog.link}`}
                  className="card-title title text-dark"
                >
                  {blog.title}
                </Link>
              </h5>
              <div className="post-meta d-flex justify-content-between mt-3">
                <span className="text-muted  d-flex">
                  <i className="mdi mdi-clock"> </i>{" "}
                  <span className="ms-1"> {blog.timeToRead} min</span>
                </span>

                <Link to={`/blog${blog.link}`} className="text-muted readmore">
                  Read More <i className="mdi mdi-chevron-right"></i>
                </Link>
              </div>
            </CardBody>
            <div className="author">
              <small className="text-light user d-block">
                <i className="mdi mdi-account"></i> {blog.author}
              </small>
              <small className="text-light date">
                <i className="mdi mdi-calendar-check"></i> {blog.date}
              </small>
            </div>
          </Card>
        </Col>
      ))}
    </>
  )
}

export default BlogBox
